import { UButton } from "../common/ui.buttons";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { UMargin, USection } from "../common/ui.page";
import { GREY, WHITE } from "../style/theme";
import { WCodexIcon } from "./wh.ui.icons";


export function CBackButton(props) {

    return <UButton
        startIcon={<ArrowBackIcon />}
        variant="contained"
        {...props}
        sx={{
            width: 300,
            borderRadius: 0,
            background: 'linear-gradient(90deg, rgba(30,30,30,1) 40%, rgba(30,30,30,0) 70%, rgba(30,30,30,0) 100%)',
            ...props.sx,
        }} />
}

export function CBackToMain(props) {
    const { codex, ...rest } = props;
    return <USection>
        <UMargin margin={4}>
            <UButton sx={{
                padding: 0,
                paddingX: 4,
                background: GREY[300],
                color: WHITE,
                borderRadius: 10,

            }} page=" " startIcon={<ArrowBackIcon />}>
                <WCodexIcon size={24} name={codex} />
            </UButton>
        </UMargin>
    </USection>
}